/** Formats a raw 0–1 similarity score as a percentage with two decimal places. */
export function formatSimilarityScore(score: number): string {
    return `${(score * 100).toFixed(2)}%`;
}
